import { useState } from 'react';

const KEY = 'diceColor';
const DEFAULT = '#ffad23';

export function useDiceColorSetting() {
  const [color, setColor] = useState(() => localStorage.getItem(KEY) || DEFAULT);
  const updateColor = (newColor) => {
    localStorage.setItem(KEY, newColor);
    setColor(newColor);
  };
  return [color, updateColor];
}
